<template>
    <div>
        <div class="small">
            <line-chart :chart-data="datacollection"></line-chart>
            <button class="button is-info" @click="fillData()">Randomize</button>
        </div>
    </div>
</template>

<script>
    import LineChart from '../../utils/LineChart.js'

    export default {
        name: "EffLinaChart",
        components: {
            LineChart
        },
        data() {
            return {
                datacollection: null
            }
        },
        mounted() {
            this.fillData()
        },
        methods: {
            fillData() {
                this.datacollection = {
                    labels: ['Ocak', 'Şubat', 'Mart', 'Nisan', 'Mayıs', 'Haziran','Temmuz','Ağustos','Eylül','Ekim','Kasım','Aralık'],
                    datasets: [
                        {
                            label: 'Data One',
                            backgroundColor: '#3a27f8',
                            data: [this.getRandomInt(), this.getRandomInt(),
                                this.getRandomInt(),this.getRandomInt(),
                                this.getRandomInt(), this.getRandomInt(),
                                this.getRandomInt(), this.getRandomInt(),
                                this.getRandomInt(), this.getRandomInt(),
                                this.getRandomInt(),
                                this.getRandomInt()]
                        }, {
                            label: 'Data Two',
                            backgroundColor: '#f87979',
                            data: [this.getRandomInt(), this.getRandomInt(),
                                this.getRandomInt(), this.getRandomInt(),
                                this.getRandomInt(), this.getRandomInt(),
                                this.getRandomInt(), this.getRandomInt(),
                                this.getRandomInt(),
                                this.getRandomInt(), this.getRandomInt(), this.getRandomInt()]
                        }
                    ]
                }
            },
            getRandomInt() {
                return Math.floor(Math.random() * (50 - 5 + 1)) + 5
            }
        }
    }
</script>

<style>
    .small {
        width: 900px;
        background-color: white;
    }
</style>
